<div class="help-dialog">
  <div class="help-dialog-header d-flex align-items-center justify-content-between">
    <div class="help-title">How to use RTK Base Analyzer (Basic Edition)</div>
    <button type="button" class="btn btn-link p-0 text-decoration-none" (click)="close()" aria-label="Close">
      <span class="material-icons">close</span>
    </button>
  </div>

  <div class="help-dialog-body">
    <div class="mb-3">
      <div class="section-title">What this tool does</div>
      <div class="text-muted">
        RTK Base Analyzer (Basic Edition) analyzes GeoAstra NTRIP Caster mount points and generates an RTK Base report,
        including base coordinates and a detailed RTCM analysis report (JSON).
      </div>
    </div>

    <div class="mb-3">
      <div class="section-title">Before you start</div>
      <div class="text-muted">
        Just select a GeoAstra mount point from the dropdown.
        If the mount point shows <strong>Offline</strong>, analysis may be unavailable until it becomes Online.
      </div>
    </div>

    <div class="mb-3">
      <div class="section-title">Workflow</div>
      <ol class="mb-2">
        <li>Select a mount point from <strong>Select a MountPoint</strong>.</li>
        <li>Choose an <strong>Analysis Duration</strong>.</li>
        <li>Click <strong>Analyze this RTK Base</strong> to start the backend task.</li>
        <li>When finished, the analysis report will appear under <strong>Analysis Result</strong>.</li>
      </ol>
      <div class="text-muted">
        Use <strong>Expand All</strong> / <strong>Collapse All</strong> to browse the JSON report.
      </div>
    </div>

    <div class="mb-1">
      <div class="section-title">Tip</div>
      <div class="text-muted">
        If you don’t see a report yet, wait a moment. You can run the analysis again if needed.
      </div>
    </div>
  </div>
</div>


